import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  flexContainer: {
    flexDirection: ['column', 'row'],
    alignItems: ['center'],
    '.left-col': {
      marginRight: [null, '37px', '78px'],
    },
  },
  imageContainer: {
    display: ['none', 'block'],
    width: ['698px'],
    minWidth: ['698px'],
    height: ['492px'],

    '.gatsby-image-wrapper': {
      marginX: 'auto',
    },
  },
  responsiveImageContainer: {
    display: ['block', 'none'],
    width: '100%',
  },
  image: {},
  contentContainer: {
    color: 'black.100',
    textAlign: ['left'],
    maxWidth: '547px',
  },
  contentTitle: {
    marginBottom: ['12px', '40px'],
  },
  contentContent: {
    marginBottom: ['6px', '0px'],
  },
};
